import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import style from './removable-service.module.less';
import { Button } from 'ui-components/components/button';
import AccountSelector from '../account-selector';
import { noop } from 'ui-components/default-props/noop';
import Global from '../../../../../../store/global-selectors';

const RemovableService = ({ serviceId, sellerProviderId, onSellerProviderIdChange = noop, onRemove = noop, className = '' }) => {
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId: serviceId.toString() }));
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const shouldDisplayAccountSelector =
    service && sellerLabelProviders.filter((s) => s.labelProviderId === service.labelProviderId)?.length > 1;
  return (
    <div className={classnames(style['removable-service'], className)}>
      <div className={style.content}>
        <div>{service.name}</div>
        {shouldDisplayAccountSelector && (
          <AccountSelector
            className={style['shipping-account-selector']}
            hideLabel
            onChange={(id) => {
              onSellerProviderIdChange(id);
            }}
            providerId={service.labelProviderId}
            sellerProviderId={sellerProviderId}
          />
        )}
      </div>

      <Button className={style['x-button']} onClick={() => onRemove(serviceId, sellerProviderId)} theme='unstyled'>
        <FontAwesomeIcon className={style.icon} icon={faXmark} />
      </Button>
    </div>
  );
};

RemovableService.propTypes = {
  serviceId: PropTypes.string.isRequired,
  sellerProviderId: PropTypes.string,
  onSellerProviderIdChange: PropTypes.func,
  onRemove: PropTypes.func,
  className: PropTypes.string,
};

export default RemovableService;
